import React from 'react';

import { Wrapper, Content, Info, Image, H5, Title, Decorate, HeaderContent } from './elements';
import { circleTexts } from './contents';

import { Space } from '@gr-monorepo/common/ui';
import { Link } from 'react-router-dom';
import { useClickStreamContext } from '../ClickStream';

const scrollToTop = () => window.scroll(0, 0);

type Props = {
  title: string;
  id: string;
};
const LoginLayout = (props: React.PropsWithChildren<{}>) => {
  const { logPageEvent } = useClickStreamContext();

  const handleClick = (obj: Props) => {
    scrollToTop();
    logPageEvent({
      eventType: `page_login_redirect_to_page_${obj.id}`,
      eventInfo: `Страница логина|переход на ${obj.title}`,
      eventSource: 'login_municipality',
    });
  };

  return (
    <>
      <Wrapper>
        <Decorate />
        <HeaderContent>{props.children}</HeaderContent>
        <Content>
          {circleTexts.map((obj, i) => (
            <Info key={i}>
              <Link to={obj.path} onClick={() => handleClick(obj)}>
                <div style={{ width: 280 }}>
                  <Image src={obj.image.path} width={280} />
                </div>
                <Space axis="vertical" size={24} />
                <Title>{obj.title}</Title>
              </Link>
              <H5>{obj.text}</H5>
            </Info>
          ))}
        </Content>
      </Wrapper>
    </>
  );
};

export default LoginLayout;
